$(document).ready(function () {

    var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (w < 1050) {
        jQuery('.ad-mobile').each(function (i, val) {
            $(this).css("visibility", "visible");
            $(this).css("display", "inline-block");
        });

        jQuery('.ad-desktop').each(function (i, val) {
            $(this).css("visibility", "hidden");
            $(this).css("height", "0px");
            $(this).css("width", "0px");
        });


    } else {

        jQuery('.ad-desktop').each(function (i, val) {
            $(this).css("visibility", "visible");
            $(this).css("display", "inline-block");
        });

        jQuery('.ad-mobile').each(function (i, val) {
            $(this).css("visibility", "hidden");
            $(this).css("height", "0px");
            $(this).css("width", "0px");
        });
    }
});
